<template>
    <div class="outer-box" >
      <h4>Reset Agency Welcome Email Template Id</h4>
  
      <div class="inner-box" style="text-align: left; width: 600px;">
        <b-alert show variant="danger">
          <b>This step is irreversible.</b> 
          <!-- Make sure that no location has a valid SaaS Plan. -->
        </b-alert>
        <input class="hl_input--wrap" type="text" placeholder="Company ID" v-model="companyId" />
        <button class="btn btn-danger mt-4" @click="clearAgencyWelcomeTemplateId">
          <moon-loader v-if="processing" :loading="true" size="21px" color="#fafafa" />
          <span v-else>Reset</span>
        </button>
        <pre v-if="response" style="background-color: #f2f7fa;padding: 16px; margin-top: 16px">{{response}}</pre>
      </div>
    </div>
  </template>
  
  <script>
  import config from "@/config";
  import { SaasService } from '@/services';

  export default {
    data() {
      return {
        companyId: '',
        companyEmail: '',
        processing: false,
        response: null
      };
    },
    methods: {
      async clearAgencyWelcomeTemplateId(){
        if(!this.companyId){
          this.response = "Company Id is Required."
          return;
        }

        this.processing = true
        try{
            let response = await SaasService.clearAgencyWelcomeTemplateId(this.companyId);
            this.response = response.data;
        }catch(error){
            this.response = error.message
        }
        this.processing = false;
        return;
      },
    }
  }
  </script>
  
  <style>
  </style>
  